import React from 'react';
import { FieldType } from 'types/FieldTypes';
import FormModal from 'components/modals/FormModal';

// Rename the name of the function:
const ImplementationPackageForm: React.FC<{ viewKey?: string }> = ({ viewKey }) => {

    const apiObject = 'implementation_package'

    // Plug in the fields and their properties:
    const fields: FieldType[] = [
        {
            name: 'name',
            label: 'billing.implementation_package.name_label',
            type: 'text',
            placeholder: 'billing.implementation_package.name_placeholder',
        },
        {
            name: 'description',
            label: 'billing.implementation_package.description_label',
            type: 'textarea',
            rows: 3,
            placeholder: 'billing.implementation_package.description_placeholder',
        },
        {
            name: 'image',
            label: 'billing.implementation_package.image_label',
            type: 'image',
            alignment: 'stacked',
            imageType: 'landscape',
            dropzoneText: 'billing.implementation_package.image_placeholder',
            apiField: {
                fileUpload: 'image_file',
                fileName: 'image_filename',
                imageDeleted: 'image_deleted'
            },
        },
        {
            type: 'price',
            name: 'price',
            label: 'billing.implementation_package.price_label',
            apiObject: 'currency',
            helperText: 'billing.implementation_package.price_helper_text',
        },
    ];

    return (
        <FormModal
            viewKey={viewKey}
            apiObject={apiObject}
            fields={fields}
        />
    );
};

export default ImplementationPackageForm;
